import React, { forwardRef, useState } from "react";
import tvIcon from "../../assets/tv.png";
import "./MarketingButton.scss";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { backToMarketing } from "../utils/shared/marketing";
import { useEvents } from "../context/EventsContext";
import Loader from "./Loader";


const MarketingButton = ({ closeEPG }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { fetchEvents } = useEvents();
    const { ref, focused } = useFocusable({
        focusKey: "MARKETING_BUTTON",
        onEnterPress: () => {
            onClick();
        },
    });

    const onClick = async () => {
        setIsLoading(true);
        const status = await backToMarketing();

        if (status === 200) {
            setIsLoading(false);
            closeEPG();
            await fetchEvents(true);
        }
    };

    return (
        <button ref={ref} className={`marketingButton ${focused && "isFocused"}`} onClick={onClick} tabIndex={0}>
            {isLoading && <Loader textColor={"#fff"} />}

            {!isLoading && (
                <span className="icon">
                    <img src={tvIcon} alt="TV icon" />
                </span>
            )}

            <span className="text">Your Marketing Channel</span>
        </button>
    );
};

export default MarketingButton;
